import React from 'react';
import { IWorkLogTab } from './interfaces';
import { useTranslation } from 'react-i18next';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import { Tab } from '../../../../../components/tabs';

export const WorkLogTab: React.FC<IWorkLogTab> = ({
  label,
  ...other
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Tab
      label={label || t('entities:plannedActivity.workLog')}
      icon={<WorkHistoryIcon />}
      {...other}
    />
  );
};
